import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'page-cookies',
  templateUrl: './cookies.component.html',
  styleUrls: ['./cookies.component.scss']
})
export class CookiesPage implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// /Users/gordan.o@nylas.com/Documents/GitHub/adluux/adluux-frontend/src/app/pages/cookies/cookies.component.ts